import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Modal } from "react-responsive-modal";
import { Strings } from "../../../resources/i18n/i18n";
import Utility from "../../../utils/Utility";
import "./CustomNotesModal.scss";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import TextFieldComponent from "../TextFieldComponent/TextFieldComponent";
class CustomNotesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            note: "",
            radioBtnValue: "",
            showTextField: "",
            textInputValue: this.props.CIID,
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.errorMessage !== prevProps.errorMessage) {
          this.setState({ errorMessage: this.props.errorMessage });
        }
    }
    onChangeNoteInput = (event) => {
        this.setState({
            note: event.target.value,
            errorMessage: "",
        })
    }
    validateAndSubmitInput = () => {
        if (this.props.isCIModal) {
            if (this.state.radioBtnValue === "") {
                this.setState({
                    errorMessage: Strings("pleaseSelectOption")
                })
            } else if (this.state.radioBtnValue === "update" && this.state.textInputValue === "") {
                this.setState({
                    errorMessage: Strings("pleaseEnterCIID")
                })
            } else if (this.state.note.trim().length < 1) {
                this.setState({
                    errorMessage: Strings("errorEmptyNote")
                });
            } else if (!Utility.isNoteValid(this.state.note)) {
                this.setState({
                    errorMessage: Strings("invalidNote")
                });
            }
            else {
                this.props.modalButtonOk.onClick(this.state.radioBtnValue === "remove", this.state.textInputValue, this.state.note)
            }
        } else if (this.state.note.trim().length < 1) {
            this.setState({
                errorMessage: Strings("errorEmptyNote")
            });
        } else if (!Utility.isNoteValid(this.state.note)) {
            this.setState({
                errorMessage: Strings("invalidNote")
            });
        } else if (this.props.isApplyExpense || this.props.isRevertExpense) {
            const percentageValue = this.state.textInputValue;
            
            if (!this.state.radioBtnValue) {

                this.setState({
                    errorMessage: Strings("pleaseSelectOption")
                })
            }else if (this.props.isRevertExpense && !Utility.isNumber(percentageValue)) {
                 this.setState({
                    errorMessage: Strings("PleaseEnterValidAmount")
                });
            } else if (this.props.isRevertExpense && (percentageValue <= 0 || percentageValue > 100)) {
                this.setState({
                    errorMessage: Strings("PercentageMustbeBetweenOneToHundred")
                });
            }
            else{
            this.props.modalButtonOk.onClick(this.state.note, this.state.radioBtnValue, this.state.textInputValue);
            }
        }
        else{
            this.props.modalButtonOk.onClick(this.state.note);
        }
    
    }

    renderModalButtons = () => {
        return (
            <Row className='customNotesModalButton'>
                <Col md={12}>
                    {this.props.modalButtonOk && (
                        <Button
                            className={
                                `buttonBackground buttonMinWidth ${this.props.modalButtonOk.disabled ? "disabled" : ""}`
                            }
                            onClick={() => this.validateAndSubmitInput()}
                            disabled={this.props.modalButtonOk.disabled}
                        >
                            {this.props.modalButtonOk.text}
                        </Button>
                    )}
                    {this.props.modalButtonCancel && <Button
                        className={
                            " primaryModalButton buttonMinWidth marginCancelButton buttonBorder"
                        }
                        onClick={() => this.props.modalButtonCancel.onClick()}
                    >
                        {this.props.modalButtonCancel.text}
                    </Button>}
                </Col>
            </Row>
        )
    }
    showNotes = () => {
        return (
            <Row className='p-2'>
                <div className='loanNoteInputField p-0 d-flex justify-center'>
                    <textarea
                        placeholder={Strings("NoteForBlackListingCedula")}
                        className='topMargin form-control noteTextArea '
                        onChange={this.onChangeNoteInput}
                        value={this.state.note}
                        cols={100}
                        rows={3}
                        maxLength={500}
                    />
                </div>
            </Row>
        );
    }
    showRevertDiscount = () => {
        const selectedDiscountDetails = this.props.selectedDiscountDetails
        return (
            <div className="pb-4">
                <Row>
                    <Col md={12}>
                        <span className="subHeading bold">
                            {Strings("currentlyAppliedDiscountInfo")}
                        </span>
                    </Col>
                    <Col md={4}>
                        <span className="titleText">{Strings("discount") + " (%)"}&nbsp;:&nbsp;</span>
                        <span className="detailText">{selectedDiscountDetails.discount}</span>
                    </Col>
                    <Col md={4}>
                        <span className="titleText">{Strings("interest") + " ($)"}&nbsp;:&nbsp;</span>
                        <span className="detailText">{Utility.getCurrencyRepresentationOfAmount(selectedDiscountDetails.interestAfterDiscount)}</span>
                    </Col>
                    <Col md={4}>
                        <span className="titleText">{Strings("emi")}&nbsp;:&nbsp;</span>
                        <span className="detailText">{Utility.getCurrencyRepresentationOfAmount(selectedDiscountDetails.emiAfterDiscount)}</span>
                    </Col>

                </Row>
                <hr className="opacity-100 mt-3" />
                <Row>
                    <Col md={12}>
                        <span className="subHeading bold">
                            {Strings("afterRevertingDiscountInfo")}
                        </span>
                    </Col>
                    <Col md={4}>
                        <span className="titleText">{Strings("interest") + " ($)"}&nbsp;:&nbsp;</span>
                        <span className="detailText">{Utility.getCurrencyRepresentationOfAmount(selectedDiscountDetails.interestBeforeDiscount)}</span>
                    </Col>
                    <Col md={4}>
                        <span className="titleText">{Strings("emi")}&nbsp;:&nbsp;</span>
                        <span className="detailText">{Utility.getCurrencyRepresentationOfAmount(selectedDiscountDetails.emiBeforeDiscount)}</span>
                    </Col>
                </Row>
            </div>
        );
    }
    handleRadioChange = (event) => {
        this.setState(
            {
                radioBtnValue: event.target.value,
                errorMessage: ""
            }
        )
        if (event.target.value === "update") {
            this.setState({
                showTextField: true,
                errorMessage: ""
            })
        } else if (event.target.value === "remove") {
            this.setState({
                showTextField: false,
                errorMessage: "",
            })
        }
    };
    renderRadioButtons = (radioButtons) => {
        return (
            <Col className='d-flex justify-content-center mt-0'>
                <RadioGroup
                    row
                    aria-label='radioButtons'
                    name={"CIID"}
                    onChange={this.handleRadioChange}
                    value={this.state.radioBtnValue}
                >
                    {Object.entries(radioButtons).map(([optionKey, option]) => (
                        <FormControlLabel
                            key={optionKey}
                            value={option.value}
                            control={<Radio />}
                            label={option.label}
                            disabled={option.disable}
                        />
                    ))}
                </RadioGroup>
            </Col>
        );
    };

    onChangeInput = (event) => {
        this.setState({
            textInputValue: event.target.value,
            errorMessage : ""
        })
    }
    renderCICodeOperations = () => {
        let disableTextField = this.state.radioBtnValue === "" || this.state.radioBtnValue === "remove"
        return (
            <Col>
                <Row className="message pb-2 mt-0">
                    <span>{Strings("updateCiId")}</span>
                </Row>
                <Row>
                    {this.renderRadioButtons({
                        radiobutton1: { label: Strings("Update"), value: "update", disable: false },
                        radiobutton2: { label: Strings("Remove"), value: "remove", disable: this.props.CIID === null }
                    })}
                </Row>
                {<Row className="justify-center">
                    <Col md={4} className='ps-0'>
                        <TextFieldComponent
                            type='number'
                            handleChange={(event) =>
                                this.onChangeInput(event)
                            }
                            value={this.state.textInputValue}
                            placeholder={Strings("CIID")}
                            disabled={disableTextField}
                        ></TextFieldComponent>
                    </Col>
                </Row>}

                <Row>
                    <hr className="opacity-100 mt-3" />
                </Row>
            </Col>
        )
    }

        renderApplyExpense = () => {
        const expenseTypes = this.props.expenseTypes || [];
        const radioButtons = expenseTypes.reduce((acc, type, index) => {
            acc[`radiobutton${index + 1}`] = { label: type.expenseType, value: type.expenseType };
            return acc;
        }, {});
        return (
            <Col>
                <Row>
                    {this.renderRadioButtons(radioButtons)}
                </Row>
                {this.props.isRevertExpense && <Row className="justify-center">
                    <Col md={4} className='ps-0'>
                        <TextFieldComponent
                            type='number'
                            handleChange={(event) =>
                                this.onChangeInput(event)
                            }
                            value={this.state.textInputValue}
                            placeholder={Strings("EnterPercentage")}
                        ></TextFieldComponent>
                    </Col>
                </Row>}

                <Row>
                    <hr className="opacity-100 mt-3" />
                </Row>
            </Col>
        )
    }

    render() {
        let errorMessagePadding;
        if (this.props.selectedDiscountDetails) {
            errorMessagePadding = "0.8rem"
        } else {
            errorMessagePadding = "0.5rem"
        }
        return (
            <div className='notesModal'>
                <Modal
                    open={this.props.open}
                    onClose={this.props.closeModal}
                    classNames={{ modal: this.props.modalWidthClass }}
                    closeOnEsc={false}
                    closeOnOverlayClick={false}
                    showCloseIcon={false}
                    center
                >
                    <Row className='notesModal'>
                        <Col md={12} className='headerModal ps-3'>
                            {this.props.modalHeader}
                        </Col>
                        <Col md={12} className="modalContent p-4">
                            {this.state.errorMessage && (
                                <Row className='errors mb-3' style={{ paddingLeft: errorMessagePadding }}>
                                    {Strings(this.state.errorMessage)}
                                </Row>
                            )}
                            {this.props.isCIModal && this.renderCICodeOperations()}
                            {this.props.modalText1 &&
                                <Row className={`customModalText ps-2 pb-2 ${this.props.modalText1Class}`}>
                                    {this.props.modalText1}
                                </Row>
                            }
                            {(this.props.isApplyExpense ||this.props.isRevertExpense) && this.renderApplyExpense()}
                            {this.props.selectedDiscountDetails && this.showRevertDiscount()}
                            {this.showNotes()}
                            {this.renderModalButtons()}
                        </Col>
                    </Row>
                </Modal>
            </div>
        )
    }
}
export default CustomNotesModal;